import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./auth/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Users from "./pages/Client/ClientManagement";
import Employee from "./pages/Employee/Employee";
import Blogs from "./pages/Blogs/Blogs";
import ProtectedRoute from "./components/ProtectedRoute";
import DocumentsPage from "./pages/Client/DocumentsPage";
import AdminPaymentManagement from './pages/PaymentManagement/AdminPaymentManagement';
import GraphBuilder from './pages/Client/GraphBuilder';
import AnnualReportBuilder from './pages/Client/AnnualReportBuilder';
import QuestionManagement from './pages/QuestionManagement/QuestionManagement';

function App() {
  return (
    <Router>
      <Routes>
        {/* Header and sidebar are not shown */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />

        {/* Apply layout only for the routes that need header and side navbar */}
        <Route path="/" element={<Layout />}>
          <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
          <Route path="/blogs" element={<ProtectedRoute> <Blogs /> </ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute> <Users /> </ProtectedRoute>} />
          <Route path="/employee" element={<ProtectedRoute> <Employee /> </ProtectedRoute>} />
          <Route path="/client/:userId/documents" element={<ProtectedRoute> <DocumentsPage /> </ProtectedRoute>} />
          <Route path="/admin/payments" element={<ProtectedRoute><AdminPaymentManagement /></ProtectedRoute>} />
          <Route path="/client/:userId/graphs" element={<ProtectedRoute><GraphBuilder /></ProtectedRoute>} />
          <Route path="/client/:userId/annual-report" element={<ProtectedRoute><AnnualReportBuilder /></ProtectedRoute>} />
          <Route path="/questions" element={<ProtectedRoute><QuestionManagement /></ProtectedRoute>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
